import PhoneLink from './PhoneLink';

export default PhoneLink;
